"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBraintreeShippingAddressGoogle = void 0;
const src_1 = require("../..");
function formatBraintreeShippingAddressGoogle(address) {
    const { administrativeArea, countryCode, postalCode, locality, name, address1, address2, phoneNumber } = address !== null && address !== void 0 ? address : {};
    const { firstName, lastName } = (0, src_1.getFirstAndLastName)(name);
    const countryIso = countryCode !== null && countryCode !== void 0 ? countryCode : '';
    const region = administrativeArea !== null && administrativeArea !== void 0 ? administrativeArea : '';
    const { code: provinceCode, name: provinceName } = (0, src_1.getProvinceDetails)(countryIso, region);
    const countryName = (0, src_1.getCountryName)(countryIso);
    return {
        'first_name': firstName,
        'last_name': lastName,
        'address_line_1': address1 !== null && address1 !== void 0 ? address1 : '',
        'address_line_2': address2 !== null && address2 !== void 0 ? address2 : '',
        'country': countryName,
        'city': locality !== null && locality !== void 0 ? locality : '',
        'province': provinceName,
        'country_code': countryIso,
        'province_code': provinceCode,
        'postal_code': postalCode !== null && postalCode !== void 0 ? postalCode : '',
        'business_name': '',
        'phone_number': phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : ''
    };
}
exports.formatBraintreeShippingAddressGoogle = formatBraintreeShippingAddressGoogle;
